// extracted by mini-css-extract-plugin
export default {"wrap":"dq-z","logoContainer":"eq-z","brandImg":"fq-z","logoImg":"gq-z","logoButton":"hq-z"};